import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from "react-redux";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './slices';
import { AuthProvider } from 'contextAPI/authProvider';
import 'Common/Components/ApiInterceptor/Api';
import { startUpdateWatcher } from './utils/checkForUpdates';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const store = configureStore({ reducer: rootReducer, devTools: true });

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}  future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// گزارش عملکرد اپلیکیشن
reportWebVitals();

// بعد از هر دیپلوی جدید، بدون نیاز به رفرش دستی یا پاک کردن کش، نسخه‌ی جدید را خودکار می‌گیرد
// (توضیح کامل در src/utils/checkForUpdates.ts). این روش مستقل از تنظیمات کش وب‌سرور کار می‌کند.
startUpdateWatcher();

// این پانل نیازی به سرویس‌ورکر/قابلیت آفلاین ندارد. نسخه‌ی قبلی سرویس‌ورکر همیشه index.html را
// از کش برمی‌گرداند (cache-first بدون invalidation)، پس بعد از هر دیپلوی جدید، کاربران نسخه‌ی
// قدیمی و ناسازگار برنامه را می‌دیدند (صفحه‌ی سفید یا گیر کردن در ورود) مگر این‌که دستی کش
// مرورگر را پاک می‌کردند. این‌جا هر سرویس‌ورکر قبلاً نصب‌شده را حذف و کش‌هایش را پاک می‌کنیم
// تا مرورگر همیشه مستقیم از سرور بخواند.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
  });
}

